import React from 'react'
import {BsLinkedin} from 'react-icons/bs'
import {BsGithub} from 'react-icons/bs'
import './header.css'

const HeaderSocials = () => {
  return (
    <div className='headers_socials'> 
        <a href='https://www.linkedin.com/in/hazel-cruz/' target='_blank'><BsLinkedin/></a>&nbsp;
        <a href='https://github.com/snowhite414?tab=repositories' target='_blank'><BsGithub/></a>
    </div>
  )
}

export default HeaderSocials